// ante-react-kit/src/pos/AntPOSShiftCluster/index.js
// Cụm 3 nút cho POS toolbar (khớp với POS mới AROrderGoodCounter/TopBar):
// Cắt ca (chỉ khi đang in-shift), Khoá màn hình, Bật/tắt tự khoá.
import React, { useState } from 'react';
import AntAuth from '../../utils/AntAuth';
import AntShiftActionOverlay from '../../components/AntShiftActionOverlay';
import { lockNow, isAutoLockEnabled, setAutoLockEnabled, isShiftFeatureEnabled, isLockFeatureEnabled } from '../../components/AntLockScreen';
import './index.scss';

export default function AntPOSShiftCluster(props) {
    const [popup, setPopup] = useState(null); // 'checkout' | null
    const [autoLockOn, setAutoLockOn] = useState(isAutoLockEnabled());

    // Gating đồng bộ với AROrderGoodCounter/TopBar:
    // - Cắt ca: cần shiftFeatureOn (manages_work_shift) + đang in-shift.
    // - Khoá / Tự khoá: cần lockFeatureOn (PIN cá nhân luôn có, default '111111').
    const shiftFeatureOn = isShiftFeatureEnabled();
    const lockFeatureOn = isLockFeatureEnabled();
    const isInShift = AntAuth.getSessionInfo('employee_session_status') === 'InProgress';
    const showShiftBtn = shiftFeatureOn && isInShift;

    const handleCheckout = () => setPopup('checkout');
    const handleLockClick = () => lockNow();
    const handleAutoLockToggle = () => {
        const next = !autoLockOn;
        setAutoLockEnabled(next);
        setAutoLockOn(next);
    };

    const handlePopupDone = () => {
        setPopup(null);
        AntAuth.refreshToken(false, null, null, null);
        try { window.location.reload(); } catch (_) {}
    };

    return (
        <div className="apt-pos-shift-cluster">
            {showShiftBtn && (
                <button
                    type="button"
                    className="apt-pos-toolbar-text-btn"
                    title="Cắt ca"
                    onClick={handleCheckout}
                >
                    <i className="dx-icon-runner" />
                    <span>Cắt ca</span>
                </button>
            )}

            {lockFeatureOn && (
                <button type="button" className="apt-pos-toolbar-icon-btn" title="Khoá màn hình" onClick={handleLockClick}>
                    <i className="dx-icon-lock" />
                </button>
            )}

            {lockFeatureOn && (
                <button
                    type="button"
                    className={`apt-pos-toolbar-icon-btn ${autoLockOn ? 'is-active' : ''}`}
                    title={`Tự khoá sau 5 phút: ${autoLockOn ? 'Bật' : 'Tắt'}`}
                    onClick={handleAutoLockToggle}
                >
                    <i className="dx-icon-clock" />
                </button>
            )}

            {popup && (
                <AntShiftActionOverlay
                    mode={popup}
                    session={{
                        employee_code: AntAuth.getSessionInfo('employee_code'),
                        employee_name: AntAuth.getSessionInfo('employee_name'),
                        employee_session_status: AntAuth.getSessionInfo('employee_session_status'),
                        shift_id: AntAuth.getSessionInfo('shift_id'),
                        store_name: AntAuth.getSessionInfo('store_name'),
                        store_code: AntAuth.getSessionInfo('store_code')
                    }}
                    onDone={handlePopupDone}
                    onClose={() => setPopup(null)}
                />
            )}
        </div>
    );
}
